import { useAppConstantsContext } from '@ltvco/refresh-lib/ctx';
import { useEffect } from 'react';

import { LegalIntelligenceMain } from './components';
import { LegalIntelligenceExploreByProductSection } from './sections/LegalIntelligenceExploreByProductSection';
import { LegalIntelligenceHeroSection } from './sections/LegalIntelligenceHeroSection';
import { LegalIntelligenceToolsSection } from './sections/LegalIntelligenceToolsSection';

export function LegalIntelligenceLanding() {
  const { data: appConstantsData } = useAppConstantsContext();
  const brandName = appConstantsData?.brandName ?? '';

  useEffect(() => {
    const previous = document.title;
    document.title = brandName
      ? `Legal Intelligence - ${brandName}`
      : 'Legal Intelligence';
    return () => {
      document.title = previous;
    };
  }, [brandName]);

  return (
    <LegalIntelligenceMain component="main">
      <LegalIntelligenceHeroSection />
      <LegalIntelligenceToolsSection />
      <LegalIntelligenceExploreByProductSection />
    </LegalIntelligenceMain>
  );
}
